/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Substitution_May_Not_Be_RepresentedInputs */

const en_forms_users_settings_substitution_may_not_be_represented = /** @type {(inputs: Forms_Users_Settings_Substitution_May_Not_Be_RepresentedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Represented`)
};

const de_forms_users_settings_substitution_may_not_be_represented = /** @type {(inputs: Forms_Users_Settings_Substitution_May_Not_Be_RepresentedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Represented`)
};

/**
* | output |
* | --- |
* | "Represented" |
*
* @param {Forms_Users_Settings_Substitution_May_Not_Be_RepresentedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_substitution_may_not_be_represented = /** @type {((inputs?: Forms_Users_Settings_Substitution_May_Not_Be_RepresentedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Substitution_May_Not_Be_RepresentedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_substitution_may_not_be_represented(inputs)
	return de_forms_users_settings_substitution_may_not_be_represented(inputs)
});